import Button from "components/CustomButtons/Button";
import CancelIcon from "@material-ui/icons/Cancel";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { connect } from "react-redux";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import React from "react";
import TrashIcon from "@material-ui/icons/Delete";
import { closeSweetAlertStyle, sweetAlertHeaderStyle } from "../../helpers/CustomStyles";
import Snackbar from "../../../components/Snackbar/Snackbar";
import { headerStyleSuccess } from "../../helpers/CustomStyles";
import "../../components/SystemSettings/SystemSettings.css";
import { closeDetachAccountNotification } from "../../stores/actions/accountActions"
import Loading from "../Loading/Loading";

class UnbindFromSystem extends React.Component {
    state = {
        detachConfirmed: false,
        isLoaderRender: false
    }
    detachConfirmedTimeout = null;
    hidePopupTimeout = null;

    componentDidMount() {
        this.props.closeDetachAccountNotification();
    }

    componentDidUpdate() {
        const { hidePopup, handleIsUserDetachedFromSystem, closeDetachAccountNotification, detachConfirmed } = this.props
        if (detachConfirmed) {
            handleIsUserDetachedFromSystem();
            this.detachConfirmedTimeout = setTimeout(() => {
                closeDetachAccountNotification();
                this.setState({ isLoaderRender: false });
            }, 6000)
            this.hidePopupTimeout = setTimeout(() => {
                hidePopup()
            }, 3000)
        }

    }

    handleConfirm = () => {
        const { accountID, systemID, detachAccountFromSystemByID } = this.props
        this.setState({ isLoaderRender: true })
        detachAccountFromSystemByID(accountID, systemID);
    }

    componentWillUnmount() {
        clearTimeout(this.detachConfirmedTimeout);
        clearTimeout(this.hidePopupTimeout);
    }

    hideDetachNotification = () => {
        this.setState({ detachConfirmed: false })
    }

    renderMobileNotifications = () => {
        const { detachConfirmed, mobileView } = this.props;
        const headerStyle = headerStyleSuccess

        if (mobileView && detachConfirmed) {
            return (
                <h5
                    className={detachConfirmed ? "open-success-mobile-notification" : "open-fail-mobile-notification"}
                    style={headerStyle}
                >
                    {detachConfirmed ? "Account detached successfully" : "Account detached failed"}
                </h5>
            );
        }
    };

    renderNotifications = () => {
        const { mobileView, closeDetachAccountNotification, detachConfirmed } = this.props

        return (
            !mobileView
                ?
                <Snackbar
                    close
                    closeNotification={closeDetachAccountNotification}
                    color="success"
                    message="Account detached successfully"
                    open={detachConfirmed}
                    place="tc"
                    key='detach-account-success'
                />
                :
                this.renderMobileNotifications()
        )
    }

    render() {
        const { hidePopup, systemName, accountName, lastSystem } = this.props;
        const { isLoaderRender } = this.state;
        return (
            <>
                <GridContainer>
                    <GridItem xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button
                            data-testid="cancelButton"
                            simple
                            justIcon
                            color="info"
                            style={closeSweetAlertStyle}
                            onClick={hidePopup}
                        >
                            <CancelIcon
                                style={{ width: "20px", height: "20px", }}
                            />
                        </Button>
                    </GridItem>
                </GridContainer>
                <Card
                    chart
                    style={{ overflow: "visible", marginTop: "10px", marginBottom: "0" }}
                    className="unbindFromSystem"
                >
                    <CardHeader color="info" icon>
                        <CardIcon color="info">
                            <TrashIcon />
                        </CardIcon>
                        <h3
                            style={sweetAlertHeaderStyle}
                            className="unbindFromSystemHeader"
                        >
                            Unbind from the system
                        </h3>
                    </CardHeader>
                    <CardBody>
                        <form>
                            <GridContainer>
                                <GridItem xs={12}>
                                    {lastSystem
                                    ?
                                    <><span style={{ fontWeight: "500", color:"red", paddingBottom: "5px" }}>Warning: Unbinding {`${accountName}`} from {` ${systemName} `} will result in deletion of their account. This process is irreversible.</span><br/><br/></>
                                    : null}
                                    <div>
                                    Are you sure to unbind
                                    <span style={{ fontWeight: "500" }}>{` ${accountName} `}</span>
                                    from the
                                    <span style={{ fontWeight: "500" }}>{` ${systemName} `}</span>
                                    system?
                                    </div>
                                </GridItem>
                                <GridItem xs={12} style={{ margin: "15px 0 0 0 " }}>
                                    {this.renderNotifications()}
                                    <Button
                                        disabled={isLoaderRender}
                                        onClick={this.handleConfirm}
                                        data-testid="unbindButton"
                                        style={{ marginTop: "20px", transition: "0.2s", backgroundColor: isLoaderRender ? '#ccc' : '#00acc1' }}
                                    >
                                        {isLoaderRender ? <Loading transform={1} height={17} width={28} color='darkGray' /> : 'OK'}
                                    </Button>
                                </GridItem>
                            </GridContainer>
                        </form>
                    </CardBody>
                </Card >
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        detachConfirmed: state.account.detachConfirmed
    }
}
const actions = {
    closeDetachAccountNotification
}

export default connect(mapStateToProps, actions)(UnbindFromSystem);